// Copyright © Veeam Software Group GmbH

import { merge } from 'rxjs';
import { map } from 'rxjs/operators';

import { operatorEventsHub as hub } from 'api/signalr';
import { convertEventFromSignalR } from './converters';

export const onEventChanged = merge(
    hub.addRestoreSessionLogAsync,
    hub.finishRestoreSessionLogAsync,
).pipe(map(convertEventFromSignalR));
